var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoAbisConsulting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.5 19h-1.9c-.1 0-.3-.1-.3-.3l-.8-3.4h-4.1l-.8 3.4c0 .2-.2.3-.3.3h-1.9c-.2 0-.3-.1-.3-.3v-.1L34 7.3c.3-1.2 1.1-1.8 2.5-1.8 1.3 0 2.2.6 2.5 1.8l2.9 11.3v.1c-.1.2-.2.3-.4.3zm-3.6-5.7L36.6 8c-.1-.2-.1-.3-.3-.3-.2 0-.2.1-.3.3l-1.3 5.3h3.2z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2 14.7c0 2.8-1.4 4.5-4.3 4.5-1.2 0-2.4-.2-3.6-.5-.4-.1-.5-.2-.5-.5V5.7c0-.2.2-.4.4-.4h1.6c.2 0 .4.2.4.4v3.2c.6-.1 1.2-.1 1.7-.1 2.9 0 4.3 1.7 4.3 4.5v1.4zm-2.3-1.4c0-.8-.1-1.4-.4-1.9-.3-.4-.8-.7-1.5-.7-.6 0-1.1 0-1.7.1v6.3c.4.1 1 .1 1.7.1s1.2-.2 1.5-.7c.3-.4.4-1.1.4-1.9v-1.3z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2 7.2c0 .2-.2.4-.4.4h-1.7c-.2 0-.4-.1-.4-.4V5.6c0-.2.2-.4.4-.4h1.7c.2 0 .4.2.4.4v1.6zm0 11.5c0 .2-.2.4-.4.4h-1.7c-.2 0-.4-.2-.4-.4V9.3c0-.2.2-.4.4-.4h1.7c.2 0 .4.2.4.4v9.4z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.4 19.2c-.4 0-.9 0-1.5-.1s-1.2-.1-1.7-.3c-.2-.1-.3-.2-.3-.4v-1.1c0-.1.1-.3.3-.3h.1c1.1.1 2.1.2 3 .2.5 0 .8-.1 1-.2.2-.1.3-.4.3-.6 0-.4-.2-.6-.8-.9L58.3 14c-.9-.6-1.5-1.5-1.5-2.5 0-1.8 1.1-2.7 3.4-2.7.7 0 1.3 0 1.7.1.5.1.9.1 1.5.3.2.1.3.2.3.4v1c0 .2-.1.3-.3.3h-.1c-1-.1-2-.2-3-.2-.9 0-1.2.2-1.2.8 0 .1 0 .2.1.3.1.1.3.2.6.4l2.4 1.4c1.5.9 1.7 1.7 1.7 2.7.1 1.6-1.2 2.9-3.5 2.9z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4 18.6c0 .2-.1.3-.3.4-.8.1-1.8.2-3 .2s-2.3-.4-3.2-1.2c-.9-.8-1.5-2.3-1.5-4.4v-2.5c0-1.4.2-2.5.7-3.3.5-.8 1-1.4 1.8-1.7.7-.3 1.5-.5 2.3-.5.9 0 1.9.1 3 .3.2 0 .3.1.3.2V7c0 .1-.1.2-.2.2h-.1c-1.3-.1-2.3-.2-3-.2-1 0-1.7.3-2.3 1-.6.6-.9 1.7-.9 3.1v2.5c0 1.4.3 2.5.8 3.1.6.6 1.3 1 2.3 1 .8 0 1.8 0 3-.1h.1c.2 0 .3.1.3.3v.7h-.1z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3 14.8c0 2.7-1.4 4.4-4 4.4-1.3 0-2.3-.4-3-1.2-.7-.8-1-1.9-1-3.2v-1.4c0-1.4.3-2.4 1-3.2.8-.8 1.7-1.2 3-1.2 2.6 0 4 1.7 4 4.4v1.4zm-1.5-1.4c0-1.9-.8-3-2.4-3-1.6 0-2.4 1.1-2.4 3v1.4c0 2 .8 3 2.4 3 1.6 0 2.4-1.1 2.4-3v-1.4z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6 18.7c0 .2-.2.4-.4.4h-.9c-.2 0-.4-.2-.4-.4v-5.9c0-1.8-.6-2.4-2-2.4-.7 0-1.5.2-2.4.7v7.6c0 .2-.1.4-.3.4h-.9c-.2 0-.3-.2-.3-.4V9.5c0-.2.1-.4.3-.4h.9c.2 0 .3.1.3.4v.3c1-.6 1.9-.8 2.9-.8 2.1 0 3.1 1.3 3.1 3.7v6h.1z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9 18.5c-.6.4-1.4.6-2.5.6-1.2 0-2.1-.1-2.8-.3-.3-.1-.4-.2-.4-.4v-.6c0-.2.1-.3.3-.3h.1c1 .1 2 .2 2.8.2 1.2 0 1.8-.3 1.8-1.3 0-.3-.1-.5-.3-.7-.2-.2-.5-.5-1.1-.8l-1.7-.9c-1.2-.7-1.8-1.5-1.8-2.6 0-.9.3-1.5.9-1.9.5-.3 1.3-.5 2.3-.5.9 0 1.9.1 2.8.2.2 0 .3.2.3.4v.6c0 .2-.1.3-.3.3h-.1c-1.1-.1-2.1-.1-2.8-.1-1.2 0-1.7.2-1.7 1 0 .5.3.8 1.2 1.4l1.8 1.1c.7.4 1.2.9 1.5 1.3.3.4.4.9.4 1.4.2.8-.1 1.5-.7 1.9z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 18.7c0 .2-.1.4-.3.4h-.9c-.2 0-.3-.1-.3-.4v-.3c-1 .6-1.9.8-2.9.8-2.1 0-3.1-1.2-3.1-3.7v-6c0-.2.2-.4.4-.4h.9c.2 0 .4.1.4.4v5.9c0 1.8.6 2.4 2 2.4.7 0 1.5-.2 2.4-.7V9.5c0-.2.2-.4.4-.4h.9c.2 0 .3.1.3.4v9.2h-.2z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.8 18.7c0 .2-.1.4-.3.4h-.9c-.2 0-.3-.1-.3-.4V5.9c0-.2.1-.3.3-.3h.9c.2 0 .3.1.3.3v12.8z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.2 18.8c0 .2-.1.3-.3.3-.4.1-.8.1-1.2.1-.9 0-1.5-.2-1.9-.5-.4-.3-.6-1-.6-1.9v-6.3l-1.7-.2c-.2 0-.3-.1-.3-.3v-.5c0-.2.1-.3.3-.3h1.7V7.4c0-.2.1-.3.3-.4l.9-.1h.1c.2 0 .3.1.3.3v2h1.9c.2 0 .4.1.4.4v.6c0 .2-.2.4-.4.4h-1.9v6.3c0 .5.1.8.2.9.1.1.4.2.8.2h1c.3 0 .4.1.4.3v.5z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.2 7.2c0 .2-.2.4-.4.4h-.8c-.2 0-.4-.2-.4-.4V5.8c0-.2.1-.4.4-.4h.9c.2 0 .4.1.4.4v1.4h-.1zm0 11.5c0 .2-.2.4-.4.4h-.8c-.2 0-.4-.2-.4-.4V9.5c0-.2.1-.4.4-.4h.9c.2 0 .4.1.4.4v9.2h-.1z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133 18.7c0 .2-.2.4-.4.4h-.9c-.2 0-.4-.2-.4-.4v-5.9c0-1.8-.6-2.4-2-2.4-.7 0-1.5.2-2.4.7v7.6c0 .2-.1.4-.4.4h-.9c-.2 0-.3-.2-.3-.4V9.5c0-.2.1-.4.3-.4h.9c.2 0 .3.1.3.4v.3c1-.6 1.9-.8 2.9-.8 2.1 0 3.1 1.3 3.1 3.7v6h.2z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.1 10c0 .2-.1.3-.3.3l-.6.1c.4.4.6 1.1.6 1.9v.1c0 2.1-1.3 3.1-4 3.1-.8 0-1.5-.1-2.1-.4-.3.1-.4.3-.4.6s.2.5.6.6l2.7.7c.7.2 1.3.4 1.8.6 1 .4 1.6 1 1.6 2.1v.1c0 1.8-1.2 2.8-4.1 2.8-2.8 0-4.1-1-4.1-2.9v-.2c0-1 .5-1.8 1.1-2.3l-.1-.1c-.6-.2-.8-.8-.8-1.4 0-.5.3-1 .7-1.3-.6-.5-.8-1.2-.8-2.1v-.1c0-.9.3-1.7.9-2.3.6-.6 1.6-.9 3.1-.9h3.9c.2 0 .4.2.4.4v.6h-.1zm-1.7 9.7c0-.3-.2-.6-.5-.8-.3-.2-.9-.4-1.7-.6l-2-.5c-.6.5-.9 1-.9 1.8v.2c0 1.1.6 1.6 2.6 1.6 1 0 1.6-.1 2-.4.4-.3.5-.7.5-1.2v-.1zm-.2-7.4c0-.6-.2-1.1-.5-1.4-.4-.3-1-.5-1.9-.5-.9 0-1.5.2-1.9.5-.4.3-.5.8-.5 1.4v.1c0 .5.2.9.5 1.3.4.4 1 .5 1.9.5.9 0 1.5-.2 1.9-.5.4-.3.5-.8.5-1.4z",
    fill: "#414042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4 24.8c.1.5.5 1 1.1 1H15c.6 0 .7-.3.3-.7l-6-6c-.6.4-1.1.9-1.7 1.3.8 1.2 1.5 2.7 1.8 4.4z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 1.1c-1.5 2.7-3.2 5.3-5.1 7.7 2.8 3.2 4.8 7.2 5.8 11.6.5 2.2.5 2.2.5 0V4c.1-1.1-.4-2.1-1.2-2.9z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 24.8c0 .6.5 1 1.1 1h7.2c.5 0 .7-.3.3-.7L14.5 14.5c-.5.5-1 1-1.5 1.4 1.9 2.5 3.2 5.5 3.5 8.9z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.3 25.8H8c.6 0 .7-.3.3-.7L5.2 22c-1.4.9-2.9 1.8-4.4 2.5.5.7 1.4 1.3 2.5 1.3z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 10.8v4.5c0 .6.4 1 1 1.1 2.7.4 5 1.9 6.5 3.9.6-.4 1.2-.8 1.7-1.3L.7 10.5c-.4-.4-.7-.2-.7.3z",
    fill: "#0083CA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8 0H5.4c-2.2 0-2.2.1 0 .5C11 1.7 15.9 4.7 19.5 8.9c1.9-2.4 3.6-5 5.1-7.7C23.8.4 22.8 0 21.8 0z",
    fill: "#6DCFF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1v7.2c0 .6.4 1 1 1.1 4.9.5 9.1 3 12 6.6.5-.5 1-.9 1.5-1.4L.7.7C.3.3 0 .4 0 1z",
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 17.8v4.7c0 .8.3 1.5.7 2 1.5-.8 3-1.6 4.4-2.5L.7 17.6c-.4-.5-.7-.4-.7.2z",
    fill: "#005BAA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 7.507,
    y1: 20.282,
    x2: 14.109,
    y2: 26.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A3DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.182,
    stopColor: "#00A1DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#009AD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#008FD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#0083CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 19.597,
    y1: 6.094,
    x2: 30.611,
    y2: 17.108,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.166,
    stopColor: "#B2E3FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#9CDCF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687,
    stopColor: "#76D1F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#6DCFF6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 12.277,
    y1: 16.585,
    x2: 23.256,
    y2: 27.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DCFF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#68CEF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.263,
    stopColor: "#54CAF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#24C4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.537,
    stopColor: "#00BCF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.675,
    stopColor: "#00B3F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    stopColor: "#00AEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 2.434,
    y1: 22.718,
    x2: 6.878,
    y2: 27.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A8ECC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    stopColor: "#478BCA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#3D83C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#2A76BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#0067B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.836,
    stopColor: "#005BAA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h143.1v25.8H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAbisConsulting);
export default __webpack_public_path__ + "static/media/logo-abis-consulting.b1f1e24a98a0ff3922c292c5ce97ec80.svg";
export { ForwardRef as ReactComponent };